/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import InputForm from '@/components/atoms/input/InputForm'
import * as yup from "yup";
import { handleChangeField, handleChangeSelect } from '@/utility/helper/dataMutation';
import InputSearch from '@/components/atoms/input/inputSearch';
import { StyledButton, BlogPagination } from '@/components';
import { CardLatestNews, GeneralEmptyData, MetaData, PageLoading } from '@/components/atoms';
import useBlogQuery from '@/utility/hooks/apiHooks/useBlog';
import route_list from '@/constant/routeUrl';
import { getLanguage } from '@/utility/helper/generalHandler';
import Head from 'next/head';
import DataHandlerContext from '@/utility/context/dataHandler';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSeoMetadata } from '@/utility/apiProcess/seo/server';
import BlogCard from "@/components/organism/card/blog-card";

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'blog'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

	return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'blog'])),
		},
	}
}

const Press = (props) => {
  const {language, token, role, dataUser, dispatch}:any = useContext(DataHandlerContext)
	const { t } = useTranslation('blog')
	const router = useRouter()
  const [timer, setTimer] = useState<NodeJS.Timeout | number>(0)
	const [formToState, setFormToState] = useState([
    {
      title: "",
      placeholder: 'Choose Status',
      type: 'select',
      value: '',
      name: 'keterangan',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: [
        { value: 'Evaluasi', label: 'Evaluasi' },
        { value: 'Evaluasi 2', label: 'Evaluasi 2' },
        { value: 'Evaluasi 3', label: 'Evaluasi 3' }
      ],
    },
		{
      title: "",
      placeholder: 'Choose Status',
      type: 'select',
      value: '',
      name: 'keterangan2',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: [
        { value: 'Evaluasi', label: 'Evaluasi' },
        { value: 'Evaluasi 2', label: 'Evaluasi 2' },
        { value: 'Evaluasi 3', label: 'Evaluasi 3' }
      ],
    },
		{
      title: "",
      placeholder: 'Search Article',
      type: 'search',
      value: '',
      name: 'search',
      error: '',
    },
  ])
	const {blogList, startBlogList, blogPageInfo, featuredBlog, startFeatureBlogList, loadingBlogList, loadingFeaturedBlogList } = useBlogQuery()
  const [currentLang, setCurrentLang] = useState(language)
	const lang = language

	const handleOnChange = (event:any, targetMutation:any, setTargetMutation:any) => {
    let clone_filter = _.cloneDeep(formToState)
    const targetType = event.target.type
    if(targetType === 'search') {
      clone_filter = handleChangeField(event, targetMutation)
    }
    setTargetMutation(clone_filter)

    clearTimeout(timer)
    const new_time = setTimeout(() => {
      handleFilter(clone_filter, 'filter_data')
    }, 2000)

    setTimer(new_time)
  }

	const handleFilter = (params:any = null, type:string) => {
    let filter_data:any = {}
    // let clone_row_pagination = _.cloneDeep(rowsPagination)

    if(type === 'filter_data') {
      params.forEach((item:any) => {
        if(item.value) {
          if(_.isObject(item.value) && !_.isDate(item.value)) {
            filter_data[item.name] = item.value.value
          } else if(_.isDate(item.value)) {
            filter_data[item.name] = dayjs(item.value).format('YYYY-MM-DD')
          } else {
            filter_data[item.name] = item.value
          }
        }
      })

      filter_data = _.merge(filter_data)
    } else if(type === 'pagination') {
      _.cloneDeep(filterSearch).forEach((item:any) => {
        if(item.value) {
          filter_data[item.name] = item.value
        }
      })
      filter_data = _.merge(filter_data, params)
    } else {
      let clone_filter = _.cloneDeep(filterSearch)
      clone_filter = clone_filter.map((item:any) => {
        return {
          ...item,
          value: ''
        }
      })
      setFilterSearch(clone_filter)
    }

		console.log(filter_data)
		startBlogList({page:1, limit: 10, order: 'desc', ...filter_data})
  }

	// useEffect(() => {

	// }, [])

	// useEffect(() => {
  //   if(lang !== currentLang) {
  //     location.reload()
  //   }
  // }, [lang])

	useEffect(() => {
    if(!_.isEmpty(language)) {
			startBlogList({page:1, limit: 10, order: 'desc'})
			startFeatureBlogList()
    }
  }, [language])

	if(loadingFeaturedBlogList || loadingBlogList) {
		return <PageLoading />
	}

	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5'>
						{t('blog.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
						{t('blog.desc')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-7xl tw-mx-auto md:px-0 tw-text-justify tw-px-7 tw-my-20'>
						<CardLatestNews data={featuredBlog}/>
						<div className='tw-flex md:tw-flex-row tw-flex-col-reverse tw-mb-10 tw-gap-4'>
							<div className='tw-grid tw-w-full'>
								{/* <InputForm
									formData={formToState.slice(0, 2)}
									onChange={handleOnChange}
									targetMutation={formToState}
									setTargetMutation={setFormToState}
									containerStyle='tw-grid md:tw-grid-cols-2 tw-grid-cols tw-gap-4 md:tw-w-[400px]'
								/> */}
							</div>
							<div className='tw-flex tw-justify-end md:tw-w-[500px] md:mt-0'>
								<InputSearch value={formToState[2].value} name={formToState[2].name} placeholder={formToState[2].placeholder} onChange={e => handleOnChange(e, formToState, setFormToState)}/>
							</div>
						</div>
						{blogList.length !== 0 ? (
							<div className='tw-grid md:tw-grid-cols-3 tw-gap-4'>
								{blogList.map((item,index) => {
									return (
                    <BlogCard key={`card-${index}`} item={item} index={index}/>
									)
								})}
							</div>
						) : (
							<GeneralEmptyData />
						)}
						{blogPageInfo.totalPage > 1 && (
							<BlogPagination infoPage={blogPageInfo} setBlogList={startBlogList} />
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Press

